export default "__VITE_ASSET__Bx_f98C___"